<p-toast position="top-right"></p-toast>
<div class="p-g req-management">
  <div class="p-g-12">
    <div class="card card-w-title" [ngClass]="{ 'loading': loading }">

      <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
          styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
      </div>

      <h1 class="req-Title" style="padding-top: 20px; padding-left: 10px;">Fees Approval</h1>

      <p-table #dt [value]="customerFees" dataKey="id" styleClass="p-table-customers req-management-table "
        [rowHover]="true" [rows]="100" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
        currentPageReportTemplate="There are {{requests?.length}} records" [filterDelay]="0"
        [globalFilterFields]="['name','country.name','representative.name','status']" class="p-table-tecfolk-fix">

        <ng-template pTemplate="caption">
          <div class="reportMainFilter">

            <div class="reportMainFields">
              <!-- <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("searchRequestByNameLabel")}}</span>
                <input pinputtext="" [(ngModel)]="searchValue" autocomplete="off" [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text"
                  name="searchValue" (keyup)="searchLocal(searchValue)"
                  class="p-inputtext p-corner-all p-state-default p-widget">

              </div> -->
              <!-- <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("statusLabel")}}</span>
                <p-dropdown class="p-inputtext" [options]="statusOptions" [placeholder]='setLabel("selectPlaceholderLabel")' name="selectStatus"
                  [style]="{'width':'100%'}" required [(ngModel)]="statusOptionValue" (ngModelChange)="getRequests()">
                </p-dropdown>
              </div>
              <div style="display: flex; align-items: center; gap: 20px; justify-content: space-around;">
                <span [pTooltip]='setLabel("searchTooltipLabel")' tooltipPosition="top" [disabled]="loading" [(ngModel)]="searchValue"
                  (click)="searchLocal(searchValue)"><i class="fa fa-search"></i></span>
                <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                  (click)="resetFilter()"> <i class="pi pi-times"></i></span>
              </div> -->

            </div>

            <!-- <div>
              <button style="background:#ffffff; color: #0e2031;" (click)="resetFilter()"
              class="p-button p-widget p-state-default p-corner-all p-button-text-only">Clear</button>
            </div> -->

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: center;">MemberShip No</th>
            <th style="text-align: center;">Name</th>
            <th style="text-align: center;">Fees</th>
            <th style="text-align: center;">Discount</th>
            <th style="text-align: center;">Status</th>
            <th style="text-align: center;">Mode</th>
            <th style="text-align: center;">Package</th>
            <th style="text-align: center;">Date</th>
            <th style="text-align: center; width: 122px;">Collected By</th>
            <th class="actionbtn">{{setLabel("actionLabel")}}</th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-requestor>
          <tr *ngIf="!(requestor.requestType === 'Registration' && !requestor.isComplete)" class="p-selectable-row ">
            <td style="text-align: center;">
              <div class="req-Lable">Name</div>
              <span class="p-column-title">{{requestor.membershipNo}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable">Name</div>
              <span class="p-column-title">{{requestor.customerName}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> Fees </div>
              <span class="p-column-title">{{requestor.pay}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> Discount </div>
              <span class="p-column-title">{{requestor.discount}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> Discount </div>
              <span class="p-column-title">{{requestor.status}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> Mode </div>
              <span class="p-column-title">{{requestor.paymentMode}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> Package </div>
              <span class="p-column-title">{{requestor.packageName}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> Date </div>
              <span class="p-column-title"> {{ requestor.date | date:'yyyy-MM-dd' }}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> enteredBy </div>
              <span class="p-column-title">{{requestor.enteredBy}}</span>
            </td>

            <td class="actionbtn-main"
              style="text-align: end; display: flex; justify-content: start; width: auto; flex-direction: row; margin-top: 18px">

              <div class="req-Lable">{{setLabel("actionLabel")}}</div>
              <!-- <button pButton type="button" pTooltip="Delete Request" class="p-button-danger p-button" icon="fa fa-times" (click)="deleteRequest(requestor)"></button> &nbsp; -->
              <!-- <button pButton type="button" style="width: 2%; border-radius: 100%;" [pTooltip]='setLabel("rejectRequestTooltipLabel")' tooltipPosition="top"
                class="p-button-danger p-button" icon="fa fa-times" (click)="reject(requestor)"></button> &nbsp; -->
                <button 
                pButton 
                type="button" 
                style="width: 2%; border-radius: 100%; background-color: green; color: white; margin-top: -18px;" 
                pTooltip="Approve Fees" 
                tooltipPosition="top" 
                icon="fa fa-check" 
                (click)="feesApproval(requestor)">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" style="text-align:left">No Feeses to be Approved</td>
          </tr>
        </ng-template>
      </p-table>
      <!-- <div class="content reportSummary" style="width: min-content; margin-left: auto;">
        <p-table [value]="tableData">
          <ng-template pTemplate="header">
            <tr>
              <th>&nbsp;</th>
              <th><strong>{{setLabel("pendingLabel")}}</strong></th>
              <th><strong>{{setLabel("approvedLabel")}}</strong></th>
              <th><strong>{{setLabel("rejectedLabel")}}</strong></th>
              <th><strong>{{setLabel("totalLabel")}}</strong></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <td>{{ rowData.column1 }}</td>
              <td>{{ rowData.Pending }}</td>
              <td>{{ rowData.Approved }}</td>
              <td>{{ rowData.Rejected }}</td>
              <td>{{ rowData.Total }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td></td>
              <td></td>
              <td colspan="2">{{setLabel("overallTotalLabel")}}</td>
              <td>{{overAllTotal}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div> -->
    </div>
  </div>
</div>